import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Input from 'components/Atom/Input';
import { Button } from 'components/Atom/Button';
import './assets/style.css';
import { AccountID } from 'assets/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { forgotPassword, login } from 'utils/copilot';
import { notification } from 'antd';
import storage from 'utils/storage';
import { setRefreshToken, setAccessToken } from 'utils/storage';
import Cookies from 'js-cookie';

const LegacyLogin = ({ isForgetMode = false }) => {
  const [isForget, setIsForget] = useState(isForgetMode);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (location.pathname === '/auth/forgot') {
      setIsForget(true);
    } else {
      setIsForget(false);
    }
    form.resetFields();
  }, [location.pathname]);

  const handleForgetClick = () => {
    setIsForget(true);
    if (!isForget) {
      navigate('/auth/forgot');
    } else {
      navigate('/auth/login');
    }
  };

  const onAddSubmit = async (values) => {
    setLoading(true);
    try {
      if (isForget) {
        const payload = {
          email: values?.email?.trim()?.toLowerCase(),
          realm: values?.account_id?.trim(),
          clientType: 'xPay',
        };
        await forgotPassword(payload);
        setLoading(false);
        notification.success({
          message: 'Success',
          description: 'If this email is registered, a reset link will be sent.',
          duration: 2,
          placement: 'bottomRight',
        });
        navigate('/auth/login');
      } else {
        const payload = {
          username: values?.email?.trim()?.toLowerCase(),
          password: values?.password,
          realm: values?.account_id?.trim(),
        };
        const response = await login(payload);
        if (response?.data?.login) {
          const accessToken = response?.data?.access_token;
          const refreshToken = response?.data?.refresh_token;
          rememberMe ? storage.setRemember(rememberMe) : storage.setRemember(rememberMe);
          setAccessToken(accessToken);
          setRefreshToken(refreshToken);
          window.localStorage.setItem('name', JSON.stringify(response?.data?.name ?? 'Admin'));
          window.localStorage.setItem('realm', response?.data?.realm);
          window.localStorage.setItem('email', response?.data?.email);
          rememberMe ? Cookies.set('accountId', response?.data?.realm, { expires: 99 }) : Cookies.remove('accountId');
          storage.setApps(response?.data?.apps);
          setLoading(false);
          navigate('/', { state: { pathname: '/auth/login', loginSuccess: true } });
        } else {
          setLoading(false);
          notification?.error({ message: response.message || 'SOMETHING WENT WRONG', placement: 'bottomRight' });
        }
      }
    } catch (err) {
      let errMessage =
        err?.response?.code == 401
          ? 'Invalid user credentials'
          : err?.response?.code == 429
            ? 'Too many requests, please try again after 5 minutes.'
            : 'Something went wrong.';
      notification?.error({ message: errMessage, placement: 'bottomRight' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-wrapper'>
      <div className='login-form login-bg-wrapper'>
        <div className='form-wrapper'>
          <img className='logo' alt='Xpay logo' src='/XPay.svg' />
          <div className='welcome-text'>
            <p className='heading'>{!isForget ? 'Hi, Welcome to Admin Portal' : 'Forgot Password'}</p>
            <div className='subtext'>
              {!isForget
                ? 'Empowering your retail success'
                : 'Enter the email associated with your account and we will send an email with instructions to reset your password.'}
            </div>
          </div>

          <div className=''>
            <Form form={form} layout='vertical' onFinish={onAddSubmit}>
              <div className=''>
                <Form.Item
                  name='account_id'
                  label='Account ID'
                  defaultValue={Cookies.get('accountId') || ''}
                  className='customInput mobileInputView'
                  rules={[
                    {
                      required: true,
                      message: 'Account id is required',
                    },
                  ]}>
                  <Input placeholder='Enter Account ID' name='account_id' className='input-placeholder' suffix={<AccountID style={{ color: '#7F7D83' }} />} />
                </Form.Item>
                <Form.Item
                  name='email'
                  label='Email'
                  className='customInput mobileInputView'
                  rules={[
                    {
                      required: true,
                      message: 'Email is required',
                    },
                    {
                      type: 'email',
                      message: 'Please enter a valid email address',
                    },
                  ]}>
                  <Input placeholder='Enter Email' name='email' className='input-placeholder' suffix={<MailOutlined style={{ color: '#7F7D83' }} />} />
                </Form.Item>
                {!isForget && (
                  <Form.Item
                    name='password'
                    label='Password'
                    className='customInputPass mobileInputView'
                    rules={[
                      {
                        required: true,
                        message: 'Password is required',
                      },
                    ]}>
                    <Input placeholder='Enter Password' name='password' type='password' className='input-placeholder' />
                  </Form.Item>
                )}
              </div>

              <div className='form-footer'>
                {!isForget && (
                  <Checkbox
                    className='checkbox'
                    onChange={() => {
                      setRememberMe(!rememberMe);
                    }}
                    defaultChecked
                    textClassName='checkbox-label'>
                    <span style={{ fontWeight: '475', color: '#000000' }}>Remember me</span>
                  </Checkbox>
                )}
                <Button className='text-button' onClick={handleForgetClick}>
                  {!isForget ? 'Forgot Password?' : 'Back to Login?'}
                </Button>
              </div>

              <div className=''>
                <Form.Item>
                  <div style={{ display: 'flex', justifyContent: 'right', marginTop: '8px' }}>
                    <Button block className='button-theme rounded-lg' htmlType='submit' loading={loading}>
                      {!isForget ? 'Login' : 'Submit'}
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </Form>
          </div>
        </div>

        <div className='form-footer-note pb-6'>
          <div className='copyright'>
            <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='pr-2 hover:underline' style={{ color: '#4f4d55' }}>
              ©{currentYear} PostEx.
            </a>{' '}
          </div>
          <p className='terms'>
            <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='pr-2 hover:underline'>
              Terms of Service
            </a>
            |
            <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='pl-2 hover:underline'>
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
      <div>
        <img src='/loginImage.svg' alt='image' />
      </div>
    </div>
  );
};

export default LegacyLogin;
